import React, { useEffect, useRef, useState } from "react";
import { v4 as uuidv4 } from "uuid";

export default function BasicCheckbox({ item, onChange, onClick, value, readOnly, disabled  }) {

	const uuid = uuidv4();

    return (
		<div>
			<input type="checkbox"
				name={item.col ?? ""}
				style={{height: "18px", verticalAlign: "middle"}}
				id={uuid}
				checked={value === "Y" ? true : false}
				readOnly={readOnly ? true : false}
				onChange={onChange && ((e) => onChange(e))}
				value={item.checkValue ?? ""}
				data-uncheck-value={item.uncheckValue ?? ""}
				disabled={disabled}
			/>
			<label htmlFor={uuid} style={{fontWeight: "normal", marginLeft: "10px"}}>{item.label}</label>
		</div>
    );
}
